"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentProductWidgetDataSchema = exports.RecentProductItemSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.RecentProductItemSchema = zod_1.z.object({
    /** 상품 id */
    id: zod_1.z.string(),
    /** 상품명 */
    title: zod_1.z.string(),
    /** 상품 링크 */
    action: zod_1.z.object({
        web: zod_1.z.string(),
        app: zod_1.z.string(),
    }),
    imageUrl: zod_1.z.string(),
    hasGoldClassBadge: zod_1.z.boolean().optional(),
    logMeta: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    score: zod_1.z.string().nullish(),
    reviewCount: zod_1.z.string().nullish(),
    description: zod_1.z.string().nullish(),
});
exports.RecentProductWidgetDataSchema = zod_1.z.object({
    header: zod_1.z
        .object({
        title: zod_1.z.string().nullish(),
        subTitle: zod_1.z.string().nullish(),
        more: common_1.WidgetMoreSchema.optional(),
    })
        .nullish(),
    items: zod_1.z.array(zod_1.z.object({
        items: zod_1.z.array(zod_1.z.object({
            id: zod_1.z.string(),
            action: zod_1.z.object({
                app: zod_1.z.string(),
                web: zod_1.z.string(),
            }),
            image: zod_1.z.object({
                height: zod_1.z.number(),
                width: zod_1.z.number(),
                url: zod_1.z.string(),
                unit: zod_1.z.enum(['FIXED']),
            }),
            title: common_1.CommonResponseItemPropertyDto,
            position: zod_1.z.nullable(zod_1.z.number()),
            discountBadge: zod_1.z.nullable(zod_1.z.string()),
            locationDescription: zod_1.z.nullable(zod_1.z.string()),
            ranking: zod_1.z.nullable(zod_1.z.string()),
            review: zod_1.z.nullable(zod_1.z.object({
                type: zod_1.z.string(),
                score: common_1.CommonResponseItemPropertyDto,
                count: common_1.CommonResponseItemPropertyDto,
                description: common_1.CommonResponseItemPropertyDto,
            })),
            caption: zod_1.z.nullable(zod_1.z.object({
                title: common_1.CommonResponseItemPropertyDto,
                badge: zod_1.z.nullable(zod_1.z.string()),
            })),
            badges: zod_1.z.array(zod_1.z.unknown()),
            description: zod_1.z.nullable(zod_1.z.string()),
            location: zod_1.z.nullable(zod_1.z.string()),
            benefits: zod_1.z.array(zod_1.z.unknown()),
            availableQuantity: zod_1.z.nullable(zod_1.z.string()),
            features: zod_1.z.array(zod_1.z.unknown()),
            prices: zod_1.z.array(zod_1.z.unknown()),
            notices: zod_1.z.array(zod_1.z.unknown()),
            memberClassBadge: common_1.CommonResponseItemPropertyDto.nullable(),
            logMeta: zod_1.z.object({
                object: zod_1.z.string(),
                objectType: zod_1.z.string(),
                position: zod_1.z.number().nullable(),
                reviewGroup: zod_1.z.object({
                    count: zod_1.z.string().nullable(),
                    score: zod_1.z.string().nullable(),
                }),
                productCategoryId: zod_1.z.string(),
                rentPriceMemberCode: zod_1.z.nullable(zod_1.z.string()),
                stayPriceMemberCode: zod_1.z.nullable(zod_1.z.string()),
                badgeMemberCode: zod_1.z.nullable(zod_1.z.string()),
            }),
        })),
    })),
    logMeta: common_1.WidgetLogMeta,
});
